import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { Breadcrumb } from 'components/layout/Breadcrumb';
import { newBlueprintRoute } from '../Blueprints.routes';
import { BlueprintWizard } from './BlueprintWizard';

export default function NewBlueprint() {
  const { t } = useTranslation();

  return (
    <>
      <Breadcrumb routes={[newBlueprintRoute]} />
      <Typography variant="h1" style={{ margin: 0 }}>
        {t('blueprints:overview.buttons.newBlueprint')}
      </Typography>
      <Box mt={3}>
        <BlueprintWizard />
      </Box>
    </>
  );
}
